import Vue from 'vue'
import App from './App.vue'
import router from './router'
import DataV from '@jiaminghi/data-view'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "@/assets/normalize.css"
import "@/styles/base.css"

Vue.use(DataV)
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
